const SearchEnum = Object.freeze({
  Čeština: 'Vyhledávání',
  Deutsch: 'Suche',
  Français: 'Rechercher',
  Slovenčina: 'Vyhľadávanie',
  Español: 'Busque en',
  English: 'Search Jobs',
})

export default SearchEnum
